import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getPurchaseToken } from 'actions/memberships';
import { PurchaseForm } from 'components/User/Card/PurchaseForm';
import { goToCustomUrl } from 'controls/utils';

import { Button } from 'components/atoms/Button/Button';

import './_MembershipItem.scss';
import { MEMBERSHIPS_ACTIONS } from '../constants';

export const MembershipItem = ({
  item, content = null, hasCTABtn = true, className = '',
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [purchaseToken, setPurchaseToken] = useState(false);
  const [CTAlabel, setCTAlabel] = useState('');

  /* use relative path or might be problems redirecting
  https://rolandvs.atlassian.net/browse/RCP-5056
  */
  const loginAndRedirectUrl = `${window.location.origin}/roland-account/login?redirect=${window.location.origin}${process.env.REACT_APP_BASE_PATH}`;
  const accountDetailsUrl = `${window.location.origin}/roland-account`;

  const goToLogin = () => {
    window.location.href = loginAndRedirectUrl;
  };

  const {
    offerId,
    productIds,
    customerEligible,
    isActive,
    isFreeTrial,
    isUpgrade,
    isPurchasable,
  } = item;

  const getCTALabel = useCallback(() => {
    if (isFreeTrial) {
      return MEMBERSHIPS_ACTIONS.freeTrial;
    }

    if (isActive) {
      return MEMBERSHIPS_ACTIONS.active;
    }

    if (isUpgrade) {
      return MEMBERSHIPS_ACTIONS.upgrade;
    }

    if (isPurchasable) {
      return MEMBERSHIPS_ACTIONS.purchasable;
    }

    return MEMBERSHIPS_ACTIONS.unavailable;
  }, [isFreeTrial, isActive, isUpgrade, isPurchasable]);

  useEffect(() => {
    setCTAlabel(getCTALabel());
  }, [getCTALabel]);

  const getTokenAndPay = useCallback(async () => {
    setLoading(true);
    const token = await dispatch(getPurchaseToken(offerId, productIds));

    if (token !== false) {
      setPurchaseToken(token);
      setShowModal(true);
    }

    setLoading(false);
  }, [dispatch, offerId, productIds]);

  const onItemCancel = () => {
    setShowModal(!showModal);
  };

  const getCTAAction = () => {
    if (customerEligible) {
      if (!userInfo.guest) {
        getTokenAndPay();
      } else {
        goToLogin();
      }
    } else if (CTAlabel === MEMBERSHIPS_ACTIONS.active) {
      goToCustomUrl(accountDetailsUrl);
    }
  };

  return (
    <div className={`membership-item ${className}`}>
      {showModal && (
        <PurchaseForm
          url={`${process.env.REACT_APP_BUY_SCRIPT}?data=${purchaseToken}&session=${userInfo?.idToken}`}
          onCancel={onItemCancel}
        />
      )}
      <div className='membership-item__segment'>
        {content}
        {hasCTABtn
          ? (
            <Button
              text={CTAlabel}
              extraStyle='self-center'
              loading={loading}
              disabled={CTAlabel === MEMBERSHIPS_ACTIONS.unavailable}
              onClick={getCTAAction}
            />
          )
          : null}
      </div>
    </div>
  );
};

MembershipItem.propTypes = {
  item: PropTypes.object.isRequired,
  content: PropTypes.node,
  hasCTABtn: PropTypes.bool,
  className: PropTypes.string,
};
